import secondaryComponents from "../../../secondaryComponents";
import { BankEmptyIcon } from "../../../../assets/svgIcons";
import useTransactionTable from "./useTransactionTable";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";

export const TransactionsTable = ({
  transactions,
  handleFetchTransactions,
  gotoPage,
  metaDetails,
}) => {
  const { instance } = useTransactionTable({
    transactions,
    handleFetchTransactions,
  });

  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className={`${globalStyles.tableWrapper} ${styles.lineTable}`}>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={`${styles.tableSection}`}
      >
        <div className="text-center mt-5">
          <BankEmptyIcon />
          <h5>You have no transactions</h5>
          <p>When you do, they would appear here.</p>
        </div>
      </secondaryComponents.TableHelper>

      {transactions?.length > 0 ? (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      ) : null}
    </div>
  );
};

export default TransactionsTable;
